import React from "react";

import cloneDeep from "lodash/cloneDeep";

import Table from "@cloudscape-design/components/table";
import Pagination from "@cloudscape-design/components/pagination";
import Header from "@cloudscape-design/components/header";
import Input from "@cloudscape-design/components/input";
import Button from "@cloudscape-design/components/button";
import Box from "@cloudscape-design/components/box";
import Grid from "@cloudscape-design/components/grid";
import Badge from "@cloudscape-design/components/badge";
import Preferences from "@cloudscape-design/components/collection-preferences";
import Alert from "@cloudscape-design/components/alert";
import Spinner from "@cloudscape-design/components/spinner";
import Select from "@cloudscape-design/components/select";

/* Recoil */
import { useRecoilValue, useSetRecoilState } from "recoil";
import { configStore } from "../stores/config";
import SpaceBetween from "@cloudscape-design/components/space-between";
import { playerModalStore } from "../stores/playerModal";
import { bonusesStore, promotionStore } from "../stores/promotion";
import { bonusesAddModalStore } from "../stores/promotionAddModal";
import { bonusesEditModalStore } from "../stores/promotionEditModal";
import promotionEditModal from "./BonusesEditModal";
import { getRecoil } from "recoil-nexus";
import { playerPageStore } from "../stores/playerPage";
import { fortuneWheelModalStore } from "../stores/fortuneWheelModal";
import { promotionAddModalStore } from "../stores/promotionAddModal";
import { promotionEditModalStore } from "../stores/promotionEditModal";
/* ------- */

class Promotion extends React.Component {
	constructor(props) {
		super(props);
	}

	componentDidMount() {
		this.props.Interface.loadPromotion();
	}


	handleKeyPress = (event) => {
		if (event.detail.key === "Enter") {
			setTimeout(() => {
				this.props.Interface.loadPromotion();
			}, 0);
			}
	};

	render() {
		return (
			<>
				{this.props.promotion.loaded && this.props.promotion.error.text.length ? (
					<Box
						margin={{ bottom: "m" }}
						children={
							<Alert
								type="error"
								header="Error loading data:"
								children={
									<>
										<Box variant="p" children={this.props.promotion.error.text} />
										<hr />
										<Box
											variant="p"
											children={
												<>
													request error code: {this.props.promotion.error.code} | request timestamp: {this.props.promotion.error.timestamp}
												</>
											}
										/>
									</>
								}
							/>
						}
					/>
				) : (
					<></>
				)}

				<Table
					stickyHeader="true"
					trackBy="id"
					loading={!this.props.promotion.loaded}
					sortingColumn={{ sortingField: this.props.promotion.sorting.sortingColumn.column }}
					sortingDescending={this.props.promotion.sorting.isDescending}
					onSortingChange={(sorting) => {
						this.props.setPromotion({ ...this.props.promotion, sorting: {
								...this.props.promotion.sorting,
								sortingColumn: {
									order: !sorting.detail.isDescending ? "ASC" : "DESC",
									column: sorting.detail.sortingColumn.sortingField
								},
								isDescending: sorting.detail.isDescending,
							} });

						setTimeout(() => {
							this.props.Interface.loadPromotion();
						}, 250);
					}}
					columnDefinitions={[
						{
							id: "id",
							header: "ID",
							sortingField: "id",
							cell: (item) => (
								<Button
									iconName={"status-in-progress"}
									className={[this.props.styles["btnUID"], typeof document.body.classList[0] !== "undefined" ? this.props.styles["dark"] : "", this.props.styles["blue"]].join(" ")}
									variant="normal"
									onClick={() => {
										setTimeout(() => {
											this.props.setPromotionEditModal({
												...this.props.promotionEditModal,
												show: true,
												id: item.id,
												typePromo: item.type,
												fromAmount: Number(item.fromAmount) / 100,
												toAmount: Number(item.toAmount) / 100,
												startDate: item.start.replace(" ", "T"),
												endDate: item.end.replace(" ", "T"),
												percent: item.percent,

											});
										}, 0);
									}}
									children={item.id}
								/>
							),
						},
						{ id: "fromAmount", header: "From Amount", sortingField: "fromAmount", cell: (item) => new Intl.NumberFormat("ru-RU").format(item.fromAmount / 100) + " RUB." },
						{ id: "toAmount", header: "To Amount", sortingField: "toAmount", cell: (item) => new Intl.NumberFormat("ru-RU").format(item.toAmount / 100) + " RUB." },
						{
							id: "percent",
							header: "percent",
							sortingField: "percent",
							cell: (item) => item.percent,
						},
						{ id: "start", header: "Start", sortingField: "start", cell: (item) => <>{new Date(item.start).toLocaleDateString() + " " + new Date(item.start).toLocaleTimeString()}</> },
						{ id: "end", header: "End", sortingField: "end", cell: (item) => <>{new Date(item.end).toLocaleDateString() + " " + new Date(item.end).toLocaleTimeString()}</> },
						{
							id: "type",
							header: "type",
							sortingField: "type",
							cell: (item) => item.type,
						},
					]}
					items={this.props.promotion.data}
					preferences={
						<Preferences
							cancelLabel="Cancel"
							confirmLabel="Confirm"
							pageSizePreference={{ title: "Promotions per page", options: this.props.config.promotion.preferences.perPage }}
							preferences={{ pageSize: this.props.config.promotion.perPage }}
							title="Preferences"
							onConfirm={(preferences) => {
								localStorage.setItem("promotion.perPage", preferences.detail.pageSize);
								this.props.setConfig({ ...this.props.config, promotion: { ...this.props.config.promotion, perPage: preferences.detail.pageSize } });

								setTimeout(() => {
									this.props.Interface.loadPromotion();
								}, 250);
							}}
						/>
					}
					pagination={
						<Pagination
							disabled={!this.props.promotion.loaded}
							currentPageIndex={this.props.promotion.pagination.current}
							pagesCount={this.props.promotion.pagination.total}
							onChange={(page) => {
								this.props.setPromotion({ ...this.props.promotion, pagination: { ...this.props.promotion.pagination, current: page.detail.currentPageIndex } });
								setTimeout(() => {
									this.props.Interface.loadPromotion();
								}, 250)
							}}
						/>
					}
					/*
					filter={
						<Box
							margin={{ bottom: "m" }}
							children={
								<Grid
									gridDefinition={[{ colspan: 3 }, { colspan: 3 }, { colspan: 3 }, { colspan: 3 }]}
									children={
										<>
											<Select
												filteringType="auto"
												disabled={!this.props.promotion.loaded}
												placeholder="Type"
												selectedOption={this.props.promotion.currentOption.type}
												onChange={(option) => {
													option.detail.selectedOption.type !== this.props.promotion.currentSearchType && this.props.setPromotion({ ...this.props.promotion, currentSearchType: option.detail.selectedOption.type, currentOption: { ...this.props.promotion.currentOption, type: option.detail.selectedOption } });
												}}
												options={[]}
											/>
											<Input
												disabled={!this.props.promotion.loaded}
												onKeyDown={this.handleKeyPress}
												disableBrowserAutocorrect={true}
												placeholder="UID, id, code or something"
												inputMode="search"
												type="search"
												value={this.props.promotion.currentSearch}
												onChange={this.handleInputDebounceChange}
											/>
										</>
									}
								/>
							}
						/>
					}*/
					header={
						<Box
							margin={{ bottom: "m" }}
							children={
								<Header
									children="Promotions"
									counter={
										<>
											(
											{
												this.props.promotion.pagination.count
											}
											)
										</>
									}
									actions={
										<SpaceBetween direction="horizontal" size="l">
											<Button
												iconName="add-plus"
												disabled={!this.props.promotion.loaded}
												className={[this.props.styles["players-search-button"], this.props.styles["btn"]].join(" ")}
												onClick={() => {
													setTimeout(() => {
														this.props.setPromotionAddModal({ ...this.props.promotionAddModal, show: true });
													}, 0);
												}}
												variant="primary"
												children="Add promotion"
											/>
										</SpaceBetween>
									}
								/>
							}
						/>
					}
					empty="No promocodes found with requested filter"
				/>
			</>
		);
	}
}

function withRecoil(Component) {
	return function WrappedComponent(props) {
		const promotion = useRecoilValue(promotionStore);
		const setPromotion = useSetRecoilState(promotionStore);
		const config = useRecoilValue(configStore);
		const setConfig = useSetRecoilState(configStore);
		const promotionAddModal = useRecoilValue(promotionAddModalStore);
		const setPromotionAddModal = useSetRecoilState(promotionAddModalStore);
		const promotionEditModal = useRecoilValue(promotionEditModalStore);
		const setPromotionEditModal = useSetRecoilState(promotionEditModalStore);

		return <Component {...props} promotionEditModal={promotionEditModal} setPromotionEditModal={setPromotionEditModal} promotion={promotion} setPromotion={setPromotion} config={config} setConfig={setConfig} promotionAddModal={promotionAddModal} setPromotionAddModal={setPromotionAddModal} />;
	};
}

export default withRecoil(Promotion);
